/**
 * The modal for listing closed and rejected voyages.
 */

var VRC = VRC || {};

VRC.ListVoyagesView = (function () {
	var $el;
	var _template = WELL.Handlebars.VRC.list_voyages_modal;
	var _loadingTemplate = WELL.Handlebars.VRC.progress_modal;
	var _title = 'Closed and rejected voyages';
	var $content;

	var _isInit = false;

	var init = function () {
		$el = $('#voyage_modal');
		$content = $el.find('.modal-content');
		_isInit = true;
	};

	var render = function (voyages) {
		if (!_isInit) {
			init();
		}

		var ctx = {
			title: _title,
			voyages: voyages
		};

		$content.html(_template(ctx));
		attachEvents();

	};

	var loading = function () {
		if (!_isInit) {
			init();
		}
		$content.html(_loadingTemplate({title: _title}));
		$el.modal('show', {backdrop: 'static'});
	};

	var show = function () {
		if (!_isInit) {
			init();
		}
		loading();

		var getVoyages = VRC.CommunicationService.fetchData({}, 'available_voyages');

		getVoyages.done(function (object, voyages) {
			voyages = _.sortBy(voyages, function (voyage) {
				return moment(voyage.fromDatetime, g_timeStampFormat).valueOf();
			}).reverse();
			render(voyages)
		});
	};

	var attachEvents = function () {
		attachReopenEvent();
	};

	var showMsg = function (errorMsg, type) {

		var $alert = $el.find('.alert');
		$alert.addClass(type);
		$alert.text(errorMsg);
		$alert.removeClass('hidden');

	};
	var hideMsg = function () {
		var $alert = $el.find('.alert');
		$alert.text('');
		$alert.removeClass();
		$alert.addClass('hidden');
		$alert.addClass('alert');
	};

	var switchVoyage = function (e) {
		showMsg('Submitting data is done!', 'alert-info');
		var $btn = $(e.target);
		var $row = $btn.closest('tr');
		var replaceVoyageId = parseInt($row.attr('data-voyageid'));
		var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();
		var currentVoyageId = parseInt(currentVoyage.getVoyageId());
		var fetchData = VRC.CommunicationService.fetchData({}, 'replace_voyage', {
			version: GetVersionNumber(),
			currentVoyageId: currentVoyageId,
			replaceVoyageId: replaceVoyageId
		});
		showMsg('Fetching the voyage info', 'alert-info');
		fetchData.done(function (object, data) {

			var voyage = VRC.CurrentVoyage.getCurrentVoyage();
			voyage.parse(data);
			voyage.save();

			showMsg('Successfully fetching the voyage info, fetching the rest of the data', 'alert-info');
			var fetchData = FetchData();
			fetchData.done(function () {
				VRC.VoyageNoView.update(voyage.getSeqNo());
				$el.modal('hide');
				$('.voyagelog__wrapper').show();
				VRC.VoyageStartView.hide();
			});

		});
		fetchData.fail(function (object, data) {
			showMsg(data, 'alert-danger');
		});
	};

	var attachReopenEvent = function () {
		$(".list-voyages__reopen-btn").unbind('click').click(function (e) {
			hideMsg();
			$(".list-voyages__reopen-btn").prop('disabled', true);

			if (VRC.CurrentVoyage.hasCurrentVoyage()) {
				var submitData = VRC.CommunicationService.submitData('all', true, false);
				showMsg('Submitting data for this voyage', 'alert-info');
				submitData.done(function (object, data) {
					switchVoyage(e);
				});
			}
			else {
				switchVoyage(e);
			}

		});
	};

	return {
		init: init,
		render: render,
		loading: loading,
		show: show
	}
})();
